import React, { useState } from "react";
import Header from "../header";
import MainMenu from "../mainMenu";
import menuBg from "../../assets/images/bg/menu/home.svg";
import { Helmet } from "react-helmet";

const LayOut = ({ children, title = "" }) => {
  const [openMenu, setOpenMenu] = useState(false);
  const handleOpenMenu = () => {
    setOpenMenu(!openMenu);
  };

  const handleCloseMenuMenu = () => {
    setOpenMenu(false);
  };
  return (
    <>
      <Helmet>
        <title> {title || "Clarity Cooperative"}</title>
      </Helmet>
      <MainMenu closeMenu={handleCloseMenuMenu} title="NAVIGATE" bgImage={menuBg} className={openMenu ? "active" : ""} />
      <Header openMenu={handleOpenMenu} className="headerStyleEmpty scrolled" blackLogo />
      {children}
    </>
  );
};

export default LayOut;
